<template lang="pug">
  v-row
    v-col(cols="12" md="6")
      v-card
        v-card-text
          h3 Izin Kerja Khusus
          div(v-if="jenisIzinKhusus" v-for="(item, index) in jenisIzinKhusus" :key="index"  class="mt-3") 
            v-hover(v-slot="{ hover }")
              div(class="menu d-flex align-center justify-space-between" @click="changePage(item)")
                div {{item.name}}
                v-icon(style="float:right"  :color="setupColor(hover)") mdi-arrow-right 
    v-col(cols="12" md="6")
      v-card
        v-card-text
          h3 Izin Kerja Tambahan
          div(v-if="jenisIzinTambahan" v-for="(item, index) in jenisIzinTambahan" :key="index"  class="mt-3") 
            v-hover(v-slot="{ hover }")
              div(class="menu d-flex align-center justify-space-between" @click="changePage(item)" )
                div {{item.name}}
                v-icon(style="float:right"  :color="setupColor(hover)") mdi-arrow-right 
</template>

<script>
import * as config from "../config/index.json";
export default {
  name: "MenuListPermit",
  components: {},
  data: () => ({
    config: config.default,
    jenisIzinKhusus: [],
    jenisIzinTambahan: [],
    dialogPermit: false,
    listPermit: "",
    openModalNotif: false,
  }),
  mounted(){
    let izinKhusus = [];
    let izinTambahan = [];
    config.jenisIzin.forEach(el => {
      if (el.code === 'BIB-HSE-PPO-F-071-01') return;

      if (el.group === 'Izin Kerja Khusus') {
        izinKhusus.push(el);
      } else if (el.group === 'Izin Kerja Tambahan') {
        izinTambahan.push(el);
      }
    });
    this.jenisIzinKhusus = izinKhusus;
    this.jenisIzinTambahan = izinTambahan;
  },
  methods: {
    changePage(val) {
      this.$router.push(val.route);
    },
    setupColor(hover) {
      return hover ? 'primary': 'gray';
    }
  },
};
</script>

<style>
.menu {
  /* height: 45px; */
  padding: 10px 10px 10px 20px;
  border: 2px solid #ccc !important;
  border-radius: 6px;
}
.menu:hover {
  color: #217bd4;
  background-color: #e8f1fb;
  border: 2px solid #1976d2 !important;
  cursor: pointer;
}
</style>
